import type { State, SubscribedState } from './types.tsx';

const getIsLanguagesEmptyState = (state: State): boolean =>
	state.data.languageTranslationSummaries.length === 0;
const getIsLanguageSupportHighlighted = (state: State): boolean =>
	state.data.languageTranslationSummaries.some(({ flaggedSections }) => flaggedSections > 0);

export const translationSummariesSelector = (state: State): SubscribedState => {
	const { data, ...other } = state;
	return {
		...other,
		data: {
			...data,
			isLanguagesEmptyState: getIsLanguagesEmptyState(state),
			isLanguageSupportHighlighted: getIsLanguageSupportHighlighted(state),
		},
	};
};
